import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Table, Select, Image, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import { getCurrencyInfo, isEmpty } from "utils/GlobalFunctions";
const { Option } = Select;

function TableWidget(props) {
  const [isBusy, setIsBusy] = useState(false);
  const { dataList, setDataList } = props;

  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Thumbnail",
      dataIndex: "thumbnail_image",
      render: (text, record) => {
        return (
          <Image className="detail-widget-image" src={record.thumbnail_image} />
          // <img className="detail-widget-image" src={record.thumbnail_image} />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
      },
      render: (text, record) => {
        if (record.qty < record.low_qty) {
          return <Tag color="red">{text}</Tag>;
        } else {
          return <span>{text}</span>;
        }
      },
    },
    {
      title: "Qty",
      dataIndex: "qty",
      align: "center",
      sorter: {
        compare: (a, b) => a.qty - b.qty,
      },
      render: (text) => <span>{parseFloat(text)}</span>,
    },
    {
      title: "Low Qty Limit",
      dataIndex: "low_qty",
      align: "center",
      sorter: {
        compare: (a, b) => a.low_qty - b.low_qty,
      },
      render: (text) => <span>{parseFloat(text).toFixed(2)}</span>,
    },
    {
      title: "Unit",
      dataIndex: "unit_name",
      sorter: {
        compare: (a, b) => a.unit_name.localeCompare(b.unit_name),
      },
      render: (text, record) => {
        return <span>{record.unit.name}</span>;
      },
    },
    {
      title: "Average Cost/Unit",
      dataIndex: "average_price_per_unit",
      align: "center",
      sorter: {
        compare: (a, b) => a.average_price_per_unit - b.average_price_per_unit,
      },
      render: (text) => <span>{"$(" + getCurrencyInfo() + ") " + text}</span>,
    },
    {
      title: "Selling Price Percentage",
      dataIndex: "sell_price_percentage",
      align: "center",
      sorter: {
        compare: (a, b) =>
          a.sell_price_percentage.localeCompare(b.sell_price_percentage),
      },
      render: (text) => <span>{parseFloat(text).toFixed(2)}%</span>,
    },
    {
      title: "Selling Price",
      align: "center",
      dataIndex: "sell_price",
      width: 120,
      render: (text, record) => {
        if (record.sell_price_percentage == "0") {
          return "---";
        } else {
          return (
            <span>
              {"$(" +
                getCurrencyInfo() +
                ") " +
                parseFloat(
                  (100 * record.average_price_per_unit) /
                    record.sell_price_percentage
                ).toFixed(2)}
            </span>
          );
        }
      },
    },
    {
      title: "Salable",
      align: "center",
      dataIndex: "salable",
      sorter: {
        compare: (a, b) => a.salable - b.salable,
      },
      render: (text, record) => {
        if (record.salable === "1") {
          return <div className="active-btn">Yes</div>;
        } else {
          return <div className="inactive-btn">No</div>;
        }
      },
    },
    {
      title: "Updated At",
      align: "center",
      dataIndex: "update_timestamp",
      sorter: {
        compare: (a, b) => a.update_timestamp.localeCompare(b.update_timestamp),
      },
    },
  ];
  const dataSource = dataList.map((info) => {
    return { ...info, key: info.id };
  });

  return (
    <div className="list-table">
      <Table
        pagination={
          dataList.length > 30
            ? {
                defaultPageSize: 30,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "30", "40", "50"],
              }
            : false
        }
        columns={columns}
        dataSource={dataSource}
      />
    </div>
  );
}

export default withRouter(TableWidget);
